const sp = {
  openPopup: function (url, top, left, width, height, withScroll, withResize) {
    const showScroll = (withScroll === 1) ? 'yes' : 'no'
    const doResize = (withResize === 1) ? 'yes' : 'no'
    const windowName = width + 'x' + height
    let windowAttrs = 'menubar=no,location=no,directories=no,toolbar=no'
    windowAttrs += 'screenX=' + left + ',screenY=' + top + ',width=' + width + ',height=' + height + ',scrollbars=' + showScroll + ',resizable=' + doResize
    const windowPopup = window.open(url, windowName, windowAttrs)
    if (windowPopup !== null) {
      windowPopup.focus()
    }
  },
  checkReducedMotion: function () {
    const foo = document.querySelector('html')

    // detect clients reduced-motion settings
    if (window.matchMedia) {
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
      if (reducedMotionQuery.matches) {
        foo.setAttribute('data-reduced-motion', 'reduce')
      } else {
        if (foo.getAttribute('data-reduced-motion')) {
          foo.removeAttribute('data-reduced-motion')
        }
      }
      // listen, if client changes reduced-motion settings
      reducedMotionQuery.addEventListener('change', function () {
        if (reducedMotionQuery.matches) {
          foo.setAttribute('data-reduced-motion', 'reduce')
        } else {
          if (foo.getAttribute('data-reduced-motion')) {
            foo.removeAttribute('data-reduced-motion')
          }
        }
      })
    }
  }
}

export { sp as default }
